import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import DateNav from 'core/controllers/date_navigation';
import ExtraMobileLinkView from 'core/views/extra_mobile_link';
import GoogleAnalytics from 'core/google_analytics';
import UserProgressCollection from 'screener/collections/user_progress';


/* This view is used to show screener results. */

export default Backbone.View.extend({
  initialize: function (options) {
    _.bindAll(this, 'render');

    // Templates
    this.screener_results_template = _.template(
      $('#screener-results-template').html());
    this.parentView = options && options.parentView;

    this.modal = null;
    this.done_btn = null;
    // Get any UserProgress items for the screener_set_item that were
    // completed today.
    this.collection = new UserProgressCollection();
    _.extend(this.collection.params, {
      screener_set_item: this.model.get('id'),
      completed_at__gte: DateNav.formatted_date(new Date())
    });
    this.collection.fetch({ cache: false, success: this.render });
  },

  render: function (e) {
    this.parentView.loadingView.hide();
    // The last item in the collection is the most recent
    var user_progress = this.collection.at(this.collection.length - 1);
    $('body').append(this.screener_results_template({
      screener_set_item: this.model,
      user_progress: user_progress
    }));
    this.modal = $('#screener-results-modal');
    this.done_btn = $('a.close', this.modal);
    this.modal.modal();
    this.modal.on('hidden.bs.modal', _.bind(function () {
      this.modal.remove();
      $('.modal-backdrop').remove();
    }, this));
    $('.close', this.modal).click(function (e) {
      e.preventDefault();
    });
    if (mobile) {
      // If we are in the native app, make any feedback links open
      // in a browser
      _.each($('a', this.modal).not(this.done_btn), function (link_el) {
        new ExtraMobileLinkView({ el: link_el });
      });
    }
    if (this.parentView) {
      this.parentView.trigger('screener-results', user_progress);
    }

    GoogleAnalytics.send_event(
      this.model.get('screener').slug,
      'screener-results',
      'score',
      user_progress.get('score'));
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/screener-app/screener/static/js/screener/views/screener_results.js
// module id = 164
// module chunks = 0